import { CSVFile, processCSV } from "@redotech/csv/csv-parser";

export async function parseCsvValues(
  file: File,
  possibleColumnNames?: string[],
): Promise<string[]> {
  const data: CSVFile = await processCSV(file);
  const values: string[] = [];

  for (const row of data.rows) {
    const rowValues = Object.values(row);
    if (rowValues.every((value) => !value?.toString().trim())) {
      continue;
    }

    let extractedValue: string | undefined;

    if (possibleColumnNames && possibleColumnNames.length > 0) {
      for (const colName of possibleColumnNames) {
        const value =
          row[colName] ||
          row[colName.toLowerCase()] ||
          row[colName.toUpperCase()];
        if (value) {
          extractedValue = value.trim();
          break;
        }
      }
    }

    if (!extractedValue && Object.keys(row).length > 0) {
      const firstKey = Object.keys(row)[0];
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      extractedValue = row[firstKey]?.trim();
    }

    if (extractedValue) {
      values.push(extractedValue);
    }
  }

  return values;
}
